(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.accessibility = {
    attach: function (context, settings) {
      once("accessibility", "body", context).forEach(function (block) {
        function handleFirstTab(e) {
          if (e.keyCode === 9) {
            document.body.classList.add('user-is-tabbing');

            window.removeEventListener('keydown', handleFirstTab);
            window.addEventListener('mousedown', handleMouseDownOnce);
          }
        }

        function handleMouseDownOnce() {
          document.body.classList.remove('user-is-tabbing');

          window.removeEventListener('mousedown', handleMouseDownOnce);
          window.addEventListener('keydown', handleFirstTab);
        }

        window.addEventListener('keydown', handleFirstTab);

        // Handle dropdown menus

        var el = $('.main-header li');
        el.on('mouseover keyup mouseleave', function (e) {
          if (e.keyCode === 9 | e.type === 'mouseover') {
            el.children('ul').removeClass('showElement');

            if ($(this).children("ul").length > 0) {
              $(this).children('ul').addClass('showElement');
            }
          }

          if (e.type === 'mouseleave') {
            el.children('ul').removeClass('showElement');
          }
        });
        $(".main-header .toggle-search").on('mouseover keyup mouseleave', function (e) {
          if (e.keyCode === 9 | e.type === 'mouseover') {
            el.children('ul').removeClass('showElement');
          }
        });
        $(document).on("keyup", function (e) {
          if (e.keyCode === 27) {
            el.children('ul').removeClass('showElement');
          }
        });
        $(document).on('click', function (e) {
          var $clicked = $(e.target);

          if (!($clicked.parents().hasClass("nav") || $clicked.hasClass("nav"))) {
            el.children('ul').removeClass('showElement');
          }
        });
        $(window).scroll(function () {
          el.children('ul').removeClass('showElement');
        });


      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
